import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomepageComponent} from './homepage/homepage.component';
import {MobxTicTacComponent} from './mobx-tic-tac/mobx-tic-tac.component';

const routes: Routes = [
  {
    path: '', component: HomepageComponent,
    children: [
      {path: 'mobx', component: MobxTicTacComponent, pathMatch: 'full'}
    ]
  },
  {path: '*', component: HomepageComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/home-routing.module.ts